import { Button, DatePicker, DatePickerProps } from '@sparemin/blockhead';
import dayjs, { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { useSocialShareModal } from '../SocialShareModalContext';
import useIsBlockingActionInProgress from '../useIsBlockingActionInProgress';
import { socialShareModalFooterBlock as block } from '../utils';
import ScheduledDatePreview from './ScheduledDatePreview';

export type ScheduleDateButtonProps = {
  isDisabled?: boolean;
};

const ScheduleDateButton: React.FC<ScheduleDateButtonProps> = ({
  isDisabled,
}) => {
  const [draftScheduledDate, setDraftScheduledDate] = useState<
    Dayjs | undefined
  >(undefined);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [isInvalidDate, setIsInvalidDate] = useState(false);

  const { scheduledDate, onScheduledDateChange } = useSocialShareModal();
  const isBlockingActionInProgress = useIsBlockingActionInProgress();

  const { minValue, maxValue } = React.useMemo((): Pick<
    DatePickerProps,
    'minValue' | 'maxValue'
  > => {
    const now = dayjs();

    return {
      minValue: now.add(10, 'minutes'),
      maxValue: now.add(1, 'month'),
    };
  }, []);

  return (
    <DatePicker
      {...{ minValue, maxValue }}
      isOpen={isDatePickerOpen}
      shouldCloseOnSelect={false}
      value={draftScheduledDate}
      offset={[0, 8]}
      onOpenChange={isOpen => {
        if (isOpen) {
          setDraftScheduledDate(
            scheduledDate ? dayjs(scheduledDate) : dayjs(minValue),
          );
        } else {
          onScheduledDateChange(
            isInvalidDate ? minValue?.valueOf() : draftScheduledDate?.valueOf(),
          );
        }

        setIsDatePickerOpen(isOpen);
      }}
      button={
        scheduledDate ? (
          <ScheduledDatePreview />
        ) : (
          <Button
            variant="ghost"
            className={block('schedule-button')}
            isDisabled={isDisabled || isBlockingActionInProgress}
          >
            Schedule
          </Button>
        )
      }
      onValidationChange={setIsInvalidDate}
      onChange={setDraftScheduledDate}
    />
  );
};

export default ScheduleDateButton;
